<template>
  <v-container fluid>
    <v-row>
      <v-btn class="ma-3" color="primary" @click="createOpen = true">
        <v-icon left>mdi-plus</v-icon>
        Neuer Raum
      </v-btn>
      <v-btn class="ma-3" :loading="importing" @click="importHue">
        <v-icon left>mdi-import</v-icon>
        Aus Hue importieren
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn class="ma-3" icon :loading="loading" @click="load">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-col
          v-for="room in rooms"
          :key="room.id"
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="3"
      >
        <RoomCard :room="room" :all-devices="devices" @changed="onChanged"></RoomCard>
      </v-col>
    </v-row>
    <v-row v-if="!loading && rooms.length === 0">
      <v-col class="text--secondary">
        Noch keine Räume angelegt — über „Neuer Raum“ Geräte zu einem Raum gruppieren.
      </v-col>
    </v-row>

    <!-- Anlegen-Dialog -->
    <v-dialog v-model="createOpen" max-width="500">
      <v-card>
        <v-card-title>Neuer Raum</v-card-title>
        <v-card-text>
          <v-text-field v-model="newName" label="Name" autofocus></v-text-field>
          <v-select
              v-model="newDeviceIds"
              :items="deviceItems"
              label="Geräte"
              multiple
              chips
              deletable-chips
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="createOpen = false">Abbrechen</v-btn>
          <v-btn color="primary" text :disabled="!newName" @click="create">Anlegen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="4000">{{ snackbarText }}</v-snackbar>
  </v-container>
</template>

<script>
import RoomCard from './model/RoomCard'
import { smarthausApi } from '../../services/smarthaus'

export default {
  name: 'RoomView',
  components: { RoomCard },
  data: () => ({
    rooms: [],
    devices: [],
    loading: false,
    importing: false,
    createOpen: false,
    newName: '',
    newDeviceIds: [],
    snackbar: false,
    snackbarText: '',
  }),
  computed: {
    deviceItems() {
      return this.devices
          .filter((d) => d.category === 'lamp' || d.category === 'plug')
          .map((d) => ({ text: d.display_name, value: d.id }))
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const [roomsData, devicesData] = await Promise.all([
          smarthausApi.rooms(),
          smarthausApi.devices(),
        ])
        this.rooms = roomsData.rooms
        this.devices = devicesData.devices
      } catch (e) {
        console.error('[RoomView]', e)
      } finally {
        this.loading = false
      }
    },
    async importHue() {
      this.importing = true
      try {
        const result = await smarthausApi.roomsImportHue()
        this.snackbarText = `Hue-Import: ${result.created.length} neu, `
            + `${result.updated.length} aktualisiert, ${result.unchanged.length} unverändert`
        await this.load()
      } catch (e) {
        console.error('[RoomView] importHue', e)
        this.snackbarText = 'Hue-Import fehlgeschlagen — ist die Bridge erreichbar?'
      } finally {
        this.importing = false
        this.snackbar = true
      }
    },
    async create() {
      this.createOpen = false
      try {
        await smarthausApi.roomCreate(this.newName, this.newDeviceIds)
        this.newName = ''
        this.newDeviceIds = []
      } catch (e) {
        console.error('[RoomView] create', e)
      }
      this.load()
    },
    // RoomCard liefert den aktualisierten Raum (oder null bei Löschen/Fehler).
    onChanged(room) {
      if (room) {
        const index = this.rooms.findIndex((r) => r.id === room.id)
        if (index !== -1) {
          this.rooms.splice(index, 1, room)
          return
        }
      }
      this.load()
    },
  },
}
</script>

<style scoped>

</style>
